import splitFract from './splitFract'
import repeat from './repeat'

let formatNumber = (n, beforeLength, afterLength, filler = ' ') => {
	let [beforeDot, afterDot = '0'] = splitFract(n)
  
	beforeDot = repeat(filler, beforeLength - beforeDot.length) + beforeDot
  	
	if(afterLength > 0) {
		afterDot = afterDot + repeat(filler, afterLength - afterDot.length)
		return [beforeDot, afterDot].join(',')
	} else {
		return beforeDot
	}
}

export default formatNumber


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/formatNumber.js
 **/